import { getSessionReplayProperties } from '@amplitude/session-replay-browser';
import type {
	OperationalEventPayload,
	ScreenEventPayload,
	TrackEventPayload,
	UIEventPayload,
} from '@atlassiansox/analytics-web-client';

const attributesInjector = (
	payload: OperationalEventPayload | ScreenEventPayload | TrackEventPayload | UIEventPayload,
) => {
	const sessionReplayProperties = getSessionReplayProperties();
	if (sessionReplayProperties && Object.keys(sessionReplayProperties).length > 0) {
		if (!payload.attributes) {
			// eslint-disable-next-line no-param-reassign
			payload.attributes = {};
		}
		for (const [key, value] of Object.entries(sessionReplayProperties)) {
			// eslint-disable-next-line no-param-reassign
			payload.attributes[key] = value;
		}
	}
};

export default attributesInjector;
